export const Scale = {
    h: 1e2,
    k: 1e3,
    m: 1e6,
    b: 1e9,
} as const;

export const ScaleStep = Scale.k;

export interface FormatOption {
    suffix: string;
    nextSuffix: string;
    scaleStep: number;
    fractionDigits: number;
}

export const FormatOptions: Record<(typeof Scale)[keyof typeof Scale], Readonly<FormatOption>> = {
    [Scale.h]: {
        suffix: "h",
        nextSuffix: "k",
        scaleStep: Scale.h,
        fractionDigits: 0,
    },
    [Scale.k]: {
        suffix: "k",
        nextSuffix: "m",
        scaleStep: Scale.k,
        fractionDigits: 1,
    },
    [Scale.m]: {
        suffix: "m",
        nextSuffix: "b",
        scaleStep: Scale.m,
        fractionDigits: 2,
    },
    [Scale.b]: {
        suffix: "b",
        nextSuffix: "b",
        scaleStep: Scale.b,
        fractionDigits: 3,
    },
};
